export default "__VITE_ASSET__BwEHUzZa__"